module.exports = require("./src/angularjs-dropdown-multiselect.js");


//////////////////
// WEBPACK FOOTER
// angularjs-dropdown-multiselect (bower component)
// module id = 110
// module chunks = 0